import { Flex, Paper, Radio, Text, useMantineTheme } from '@mantine/core';
import { TemplateWithoutSections } from 'src/data-capture/hooks/templates/useTemplates';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

type TemplateRowProps = {
  template: TemplateWithoutSections;
  selected: boolean;
  onSelect: (template: TemplateWithoutSections) => void;
};

export function TemplateRow({ template, selected, onSelect }: TemplateRowProps) {
  const theme = useMantineTheme();

  return (
    <Paper
      radius="12"
      withBorder
      p="md"
      role="button"
      tabIndex={0}
      onClick={() => onSelect(template)}
      style={{
        cursor: 'pointer',
        borderColor: selected ? theme.colors.brand[6] : 'var(--default-border-color)',
        userSelect: 'none',
      }}
    >
      <Flex align="center" justify="space-between" gap="md">
        <Flex align="center" gap="md" miw={0} flex={1}>
          <Radio
            checked={selected}
            onChange={() => onSelect(template)}
            color="brand"
            aria-label={`Select template ${template.displayName}`}
          />

          <Text fw={FONT_WEIGHTS.semibold} c="gray.8" size="sm" truncate>
            {template.displayName}
          </Text>

          <Text fw={FONT_WEIGHTS.medium} size="xs" c="gray.7">
            {template.description}
          </Text>
        </Flex>

        <Text size="xs" fw={FONT_WEIGHTS.medium} c="gray.7" style={{ whiteSpace: 'nowrap' }}>
          {template.createdAt
            ? new Intl.DateTimeFormat('en-US', {
                month: 'short',
                day: 'numeric',
                year: 'numeric',
              }).format(new Date(template.createdAt))
            : ''}
        </Text>
      </Flex>
    </Paper>
  );
}
